import React, { useState } from 'react';
import './Tooltip.css';

const Tooltip = ({ content, children, placement = 'top' }) => {
  const [visible, setVisible] = useState(false);

  return (
    <span
      className={`mm-tooltip-wrapper placement-${placement}`}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      onFocus={() => setVisible(true)}
      onBlur={() => setVisible(false)}
      tabIndex={0}
    >
      {children}
      {visible && content && (
        <span className="mm-tooltip" role="tooltip">
          {content}
          <span className="mm-tooltip-arrow" />
        </span>
      )}
    </span>
  );
};

export default Tooltip;


